import { Tag } from "types/Tag";

export function buildTagDeltaPayload(originalTags: Tag[], newTags: Tag[], documentId: string, documentIdProperty: string, valueProperty: string) {

    const tagsToCreate = newTags.filter(x => !originalTags.find(y => y.value === x.value));
    const tagsToRemove = originalTags.filter(x => !newTags.find(y => y.value === x.value));

    return [
        ...(tagsToCreate.map(x => ({
            [documentIdProperty]: documentId,
            [valueProperty]: x.value
        }))),
        ...(tagsToRemove.map(x => ({
            "@removed": { reason: "delete" },
            [documentIdProperty]: documentId,
            [valueProperty]: x.value
        })))
    ];
}

export function buildSingleTagPayload(newTag: string, documentId: string, documentIdProperty: string, valueProperty: string, operation: "Add" | "Remove"){
    if(operation === "Add"){
        return [{
            [documentIdProperty]: documentId,
            [valueProperty]: newTag
        }]
    }
    else{
        return [{
            "@removed": { reason: "delete" },
            [documentIdProperty]: documentId,
            [valueProperty]: newTag
        }]
    }
}


